module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-footer', {
    attrs: {
      "color": "white",
      "app": "",
      "inset": "",
      "absolute": "",
      "padless": ""
    }
  }, [_c('v-card', {
    staticClass: "text-center",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "flat": "",
      "tile": ""
    }
  }, [_c('v-card-text', {
    staticClass: "font-weight-bold text-wrap"
  }, [_c('p', {
    staticStyle: {
      "word-wrap": "break-word"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.getkobe.com/influencer-terms-use-agreement/",
      "target": "_blank"
    }
  }, [_vm._v("\n        Influencer Terms & Conditions\n      ")]), _c('br'), _c('br'), _vm._v("\n      Website\n      "), _c('a', {
    attrs: {
      "href": "https://getkobe.com/website-terms-use",
      "target": "_blank"
    }
  }, [_vm._v("Terms of Use")]), _vm._v(" and\n      "), _c('a', {
    attrs: {
      "href": "https://getkobe.com/website-privacy-policy",
      "target": "_blank"
    }
  }, [_vm._v("Privacy Policy.")]), _c('br'), _c('br'), _vm._v("\n        Patent: "), _c('a', {
    attrs: {
      "href": "https://patentscope.wipo.int/search/en/detail.jsf?docId=SG235183686&_cid=P20-KEI88S-46965-1",
      "target": "_blank"
    }
  }, [_vm._v(" KOBE 11201807777W ℗ ")]), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n      All rights reserved. Copyright © 2016-" + _vm._s(_vm.year) + "\n      "), _c('a', {
    attrs: {
      "href": "https://www.getkobe.com/",
      "target": "_blank"
    }
  }, [_vm._v(" Kobe Global Technologies Pte Ltd")]), _vm._v(".\n      ")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d994054"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/core/FooterDense.vue
// module id = 2025
// module chunks = 0